'use strict';
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isPromise = isPromise;
function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
//# sourceMappingURL=isPromise.js.map


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.3/util/isPromise.js
// module id = 114
// module chunks = 0